<div @toastAnimation [class]="toastClass()" [style.--stack-index]="index()" role="alert">
  <div class="toast-main">
    <div class="toast-content">
      <svg class="toast-icon" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="iconPath()" />
      </svg>
      <div class="toast-message" [class.font-mono]="data().type === 'debug'" [innerHTML]="data().text">
      </div>
    </div>
    <button type="button" (click)="close()" class="toast-close" aria-label="Close notification">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>
  @if (progressDuration() > 0) {
    <div class="toast-progress-track">
      <div class="toast-progress-fill" [style.animation-duration.ms]="progressDuration()"></div>
    </div>
  }
</div>
